<template>
  <div class="py-2 container-fluid">


    <div class="d-md-flex align-items-center justify-content-between mb-3">
      <div
          @click="$router.push({ name: 'system-admin-ani-group-list' })"
          class="back-link mr-2"
      >
        <svg
            class="icon"
            width="30px"
            height="30px"
            viewBox="0 0 30 30"
            version="1.1"
        >
          <path
              d="M9.82106781,14.25 L23,14.25 L23,16.25 L9.84421387,16.25 L11.6568542,18.0626404 L10.2426407,19.4768539 L7.41842728,16.6526405 L7.41421356,16.6568542 L7.00735931,16.25 L7,16.25 L7,16.2426407 L6,15.2426407 L6.00421371,15.238427 L6,15.2342133 L7.41421356,13.8199997 L7.41842728,13.8242134 L10.2426407,11 L11.6568542,12.4142136 L9.82106781,14.25 Z"
              id="path-1"
          />
        </svg>
        <p>Back to ANI Group</p>
      </div>
      <div class="d-flex align-items-center flex-wrap">

        <div class="filters mr-3">
          <div class="field">
            <search-input
                placeholder="Search for Numbers"
                v-model="filters.ani_numbers"
            />
          </div>
        </div>

        <div v-if="numbers.length > 0"
             @click="downloadNumbers"
             class="primary-button smsc-btn  mr-2"
             title="Export Numbers"
        >
          <primary-button>
            <download-icon size="1.5x" class="custom-class"></download-icon>
          </primary-button>
        </div>
        <div v-if="numbers.length > 0"
             @click="deletedSelected"
             class="primary-button smsc-btn  mr-2"
        >
          <primary-button>Deleted Selected</primary-button>
        </div>
        <router-link tag="div"
                     :to="{name: 'system-admin-ani-group-import-number', params: { uuid : uuid }}"
                     class="primary-button smsc-btn my-2 mr-2"
        >
          <primary-button>Import</primary-button>
        </router-link>

        <div
            @click="$router.push({name: '/'})"
            class="primary-button smsc-btn my-2"
        >
          <primary-button>Add TN</primary-button>
        </div>
      </div>

    </div>
    <loader :loading="loading" v-if="loading"/>
    <table class="Invoice_table">
      <thead>
      <tr class="Invoice_table_header">
        <th>
          Number
          <span v-on:click="sorting('up', 'did')" class="sorting"
          >&#8593;</span
          >
          <span v-on:click="sorting('down', 'did')" class="sorting"
          >&#8595;</span
          >
        </th>
        <th>Vendor</th>
        <th>Started On</th>
        <th>Owned By</th>
      </tr>
      </thead>
      <tbody v-if="numbers.length > 0">
      <tr class="line" v-for="(num, i) in numbers" :key="i">
        <th class="text-center">{{ num.did }}</th>
        <th class="text-center">{{ num.vendor }}item</th>
        <th class="text-center">{{ num.created_on }}item</th>
        <th class="text-center">{{ num.owned_by }}item</th>
      </tr>
      </tbody>
    </table>

    <div v-if="numbers.length > 0" class="col col-lg-7 col-md-7 col-xs-12 per-page">
      <span class="filter_by mr-2">Show Per Page:</span>
      <div class="primary-input-container choose-type perPage">
        <primary-select
            type="text"
            @input="changePerPage"
            v-model="per_page" :is-cross="false"
            class="choose-type perPage"
            placeholder="Select"
        >
          <option :value="item" v-for="(item,key) in pages" :key="key">{{ item }}</option>
        </primary-select>
      </div>
    </div>
    <div v-if="numbers.length" class="buttons-wrapper">
      <pagination-component
          @change-page="changePage($event)"
          :page="page"
          :total="totalPage"
          :perPage="per_page"
          :qnt="numbers.length"
      />
    </div>

    <div v-if="!numbers.length" class="text-center no-data-found">
      No data found
    </div>

  </div>
</template>

<script>
import {DownloadIcon} from 'vue-feather-icons'

export default {
  name: "AniNumbers",
  props: ['uuid'],
  data() {
    return {
      numbers: [],
      page: 0,
      pages: [10, 50, 100],
      per_page: 10,
      totalPage: 0,
      filter_timeout: null,
      anis: [],
      isFound: false,
      loading: true,

      filters: {
        ani_numbers: ''
      },
    }
  },
  components: {
    PrimarySelect: () => import("@/components/Inputs/PrimarySelect.vue"),
    PrimaryButton: () => import("@/components/Buttons/PrimaryButton.vue"),
    PaginationComponent: () => import("@/components/Pagination.vue"),
    SearchInput: () => import("@/components/Inputs/SearchInput.vue"),
    Loader: () => import("@/components/Loader.vue"),
    DownloadIcon
  },
  methods: {
    GetAniNumbers(id, order_dir = "asc", order_by = "did") {
      this.$store.dispatch('GetAniNumbers', {
        page: this.page || 0,
        per_page: this.per_page || 10,
        id: id,
        order_dir: order_dir,
        order_by: order_by,
      }).then(res => {
        this.numbers = res.items
        this.loading = false
        this.totalPage = res.total / res.per_page;
      })
    },
    downloadNumbers() {
      const csvContent = 'data:text/csv;charset=utf-8,' +
          this.numbers.map(e => {
            return e.did
          }).join('\n')

      var link = document.createElement('a')
      link.href = csvContent
      link.download = 'Numbers.csv'
      link.click()
    },
    changePerPage(e) {
      this.page = 0;
      this.GetAniNumbers(this.uuid);
    },
    changePage(page) {
      this.page = page;
      this.GetAniNumbers(this.uuid)
    },
    deletedSelected() {
      console.log("deleted selected")
    },
    sorting(type, sortBy) {
      let order_dir = "";
      if (type === "up") {
        order_dir = "desc";
      } else {
        order_dir = "asc";
      }

      this.order_dir = order_dir;
      this.order_by = sortBy;

      this.GetAniNumbers(this.uuid, order_dir, sortBy)
    },
    async GetList() {

      this.loading = true;
      this.isFound = false;
      await this.$store
          .dispatch("GetNumberList", {
            page: this.Page || 0,
            per_page: this.per_page || 10,
            ani_numbers: this.filters.ani_numbers,
            ani_group_uuid: this.uuid

          })
          .then((res) => {
            this.loading = false;
            if (!res.items.length) {
              this.isFound = false;
              this.anis = []
              return;
            }
            this.isFound = true;
            this.anis = res.items.map(this.transformAniList);
            this.totalPage = res.total / res.per_page;
          })
          .catch((err) => this.$error(err));
    },
  },
  watch: {
    'filters.ani_numbers': function (r) {
      clearTimeout(this.filter_timeout)

      this.filter_timeout = setTimeout(() => {
        this.GetList()
      }, 800)
    },
  },
  created() {
    this.GetAniNumbers(this.uuid)
    console.log("num", this.numbers)
    console.log("id", this.uuid)
  },

}
</script>

<style scoped lang="scss">
.table_div {
  .Invoice_table {
    width: 100%;
    margin: 21px auto 0;

    th {
      text-align: center;

      &.action {
        width: 140px;
        height: 100%;

        .actions {
          display: flex;
          justify-content: space-evenly;
          align-items: center;
          width: 100%;
        }
      }
    }

    .add-row {
      th {
        padding: 10px;

        .action-buttons {
          display: flex;
          justify-content: flex-end;
          align-items: center;

          .smsc-btn {
            margin-right: 20px;

            &:last-child {
              margin-right: 0;
            }
          }
        }
      }
    }
  }
}

table thead tr {
  background: linear-gradient(135deg, #51a3f3 0%, #51b5f3 100%);
}

table thead th:first-child {
  padding-left: 20px;
  padding-right: 30px;
  width: 22%;
}

table,
tr {
  width: 100%;
  height: 44px;
  box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -webkit-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  -moz-box-shadow: inset 0 -1px 0 0 #f0f1fa;
  background-color: #ffffff;
}

.Invoice_table tbody tr th {
  color: #212b36;
  font-weight: normal;
  font-family: "Helvetica Neue";
  height: 20px;
  font-size: 14px;
  font-weight: normal;
  line-height: 20px;
  padding: 7px 10px 7px 20px;
  text-align: left;
}

table tr th {
  padding: 7px 10px 7px 0;
}

table {
  border-collapse: collapse;
}

.Invoice_table_header th {
  color: white;
  padding-left: 10px;
  border-bottom-width: 2px;
  vertical-align: bottom;
  border-bottom: 2px solid #dee2e6;
  border: 1px solid #dee2e6;
  padding: 0.75rem;
  text-align: center;
}

.Invoice_table_popup {
  height: 30px;
  text-align: right;
  position: relative;
  padding: 0;
  float: right;

  .popup_cta {
    cursor: pointer;
    color: #55616e;
  }
}

table thead th:first-child {
  padding-left: 35px;
}

tbody th:first-child {
  padding: 5px 10px 5px 0;

  span {
    padding: 7px 0;
  }
}

tbody th.created_by {
  line-height: 20px;
  height: 20px;
  padding: 7px 0 27px 0;
}

.per-page {
  display: flex;
  align-items: center;
  margin-top: 20px;
  padding: 0;
}

.perPage {
  width: 120px;
  display: inline-block;
}

.no-data-found {
  padding: 20px;
  text-align: center;
  font-size: 20px;
  color: #e2e5ea;
  background-color: #fff;
}

.back-link {
  cursor: pointer;
  display: flex;
  align-items: center;
  fill: #51a3f3;
  color: #51a3f3;
  font-family: "Helvetica Neue";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;

  p {
    margin: 0;
  }
}
</style>